import { render, staticRenderFns } from "./winnersList.vue?vue&type=template&id=55c5881c"
import script from "./winnersList.vue?vue&type=script&lang=js"
export * from "./winnersList.vue?vue&type=script&lang=js"
import style0 from "./winnersList.vue?vue&type=style&index=0&id=55c5881c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports